export default __webpack_public_path__ + "static/media/rinaldo_bellomo.ba7929fa.jpg";